import { db } from "../../../service/API";

export class ProfileUserConnector {
  constructor(userData) {
    this.userId = userData.userId;
    this.socId = userData.socId;
    this.rightId = userData.rightId;
  }

  getUserData(uid = this.userId) {
    return new Promise((resolve, reject) => {
      db.get("/ProfileUserConnector/UserData/" + uid)
        .then((response) => {
          if (response.status == 200) {
            // TODO: RETURN AN OBJECT INSTEAD ARRAY OF ONE VALUE
            return resolve(response.data);
          } else {
            return reject("get user data failed with status " + response.status);
          }
        })
        .catch((err) => {
          return reject("get user data failed with error " + err.message);
        });
    });
  }

  getUsersData(sid = this.socId) {
    return new Promise((resolve, reject) => {
      db.get("/ProfileUserConnector/UsersData/" + sid)
        .then((response) => {
          if (response.status == 200) {
            return resolve(response.data);
          } else {
            return reject("get users data failed with status " + response.status);
          }
        })
        .catch((err) => {
          return reject("get users data failed with error " + err.message);
        });
    });
  }

  insertUserData(userObject, sid = this.socId) {
    return new Promise((resolve, reject) => {
      db.post("/ProfileUserConnector/insertUserData/", {
        sid: sid,
        user: userObject,
      })
        .then((response) => {
          if (response.status == 201) {
            return resolve(response.data);
          } else {
            return reject("insert user data failed with status" + response.status + "a server error has occured.");
          }
        })
        .catch((response) => {
          return reject(response.message);
        });
    });
  }

  updateUserData(userObject, uid = this.userId) {
    return new Promise((resolve, reject) => {
      db.put("/ProfileUserConnector/updateUserData/", {
        uid: uid,
        user: userObject,
      })
        .then((response) => {
          if (response.status == 200) {
            return resolve(response.data);
          } else {
            return reject("update user data failed with status " + response.status);
          }
        })
        .catch((err) => {
          return reject("update user data failed with error " + err.message);
        });
    });
  }

  updateUserDataWithoutPassword(userObject, uid = this.userId) {
    return new Promise((resolve, reject) => {
      db.put("/ProfileUserConnector/updateUserDataWithoutPassword/", {
        uid: uid,
        user: userObject,
      })
        .then((response) => {
          if (response.status == 200) {
            return resolve(response.data);
          } else {
            return reject("update user data without password failed with status " + response.status);
          }
        })
        .catch((err) => {
          return reject("update user data without password failed with error " + err.message);
        });
    });
  }

  enableUserData(uid, sid = this.socId) {
    return new Promise((resolve, reject) => {
      db.put("/ProfileUserConnector/enableUserData/", { uid: uid, sid: sid })
        .then((response) => {
          if (response.status == 200) {
            return resolve(response.data);
          } else {
            return reject("enable user data failed with status " + response.status);
          }
        })
        .catch((err) => {
          return reject("enable user data failed with error " + err.message);
        });
    });
  }

  disableUserData(uid, sid = this.socId) {
    return new Promise((resolve, reject) => {
      db.put("/ProfileUserConnector/disableUserData/", { uid: uid, sid: sid })
        .then((response) => {
          if (response.status == 200) {
            return resolve(response.data);
          } else {
            return reject("disable user data failed with status " + response.status);
          }
        })
        .catch((err) => {
          return reject("disable user data failed with error " + err.message);
        });
    });
  }

  deleteUserData(uid = this.userId) {
    return new Promise((resolve, reject) => {
      db.delete("/ProfileUserConnector/deleteUserData/", { uid: uid })
        .then((response) => {
          if (response.status == 204) {
            return resolve(response.data);
          } else {
            return reject("delete user data failed with status " + response.status);
          }
        })
        .catch((err) => {
          return reject("delete user data failed with error " + err.message);
        });
    });
  }

  checkLimitedDirectories() {
    return new Promise((resolve, reject) => {
      db.get("/ProfileUserConnector/checkLimitedDirectories/" + this.socId)
        .then((response) => {
          if (response.status == 200) {
            return resolve(response.data);
          } else {
            return reject("check limited directories failed with status " + response.status);
          }
        })
        .catch((err) => {
          return reject("check limited directories failed with error " + err.message);
        });
    });
  }
}
